export default [
  {
    _name: 'CSidebarNav',
    _children: [
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Dashboard',
      //   route: '/Dashboard',
      //   icon: 'cil-speedometer',
      //   _attrs: { class: 'c-active' },
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/Dashboard',
        icon: 'cil-speedometer',
        _attrs: { class: 'c-active c-sidebar-nav-item' },
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'E-Pay Transaction',
      //   to: '/EPayTransaction',
      //   icon: 'cil-wallet',
      //   color: 'success',
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Duplicate Transaction',
      //   to: '/DuplicateTransaction',
      //   icon: 'cil-money',
      // },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Learning Setting',
        route: '/TuitionSubject',
        icon: 'cil-cog',
        items: [
          {
            name: 'Subject',
            icon: 'cil-book',
            to: '/TuitionSubject'
          },
          {
            name: 'Package',
            icon: 'cil-clone',
            to: '/TuitionPackage'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Learning People',
        route: '/TuitionStudent',
        icon: 'cil-user',
        items: [
          {
            name: 'Student',
            icon: 'cil-user',
            to: '/TuitionStudent'
          },
          {
            name: 'Teacher',
            icon: 'cil-user-female',
            to: '/TuitionTeacher'
          },
          { 
            name: 'Register Student',
            icon: 'cil-user',
            to: '/RegisterStudent'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Attendance',
        route: '/TuitionAttendanceStudent',
        icon: 'cil-contact',
        items: [
          {
            name: 'Student Attendance',
            icon: 'cil-calendar-check',
            to: '/TuitionAttendanceStudent'
          },
          {
            name: 'Teacher Attendance',
            icon: 'cil-calendar-check',
            to: '/TuitionAttendanceTeacher'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Payment',
        route: '/TuitionPaymentStudent',
        icon: 'cil-dollar',
        items: [
          {
            name: 'Student Payment',
            icon: 'cil-cash',
            to: '/TuitionPaymentStudent'
          },
          {
            name: 'Teacher Payment',
            icon: 'cil-cash',
            to: '/TuitionPaymentTeacher'
          },
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Schedule',
        to: 'TuitionSchedule',
        icon: 'cil-calendar',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Schedule New',
        icon: 'cil-calendar-check',
        to: '/Scheduler'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Broadcast',
        to: 'TuitionBroadcast',
        icon: 'cil-bell',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Manage Package',
        to: '/ManagePackage',
        icon: 'cil-speedometer',
        _attrs: { class: 'c-active c-sidebar-nav-item' },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Purchase',
        to: '/PurchaseSummary',
        icon: 'cil-speedometer',
        _attrs: { class: 'c-active c-sidebar-nav-item' },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Billing',
        to: 'Billing',
        icon: 'cil-calculator',
      },
      

    ],
   
  }
]




 